import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { SupplierList } from "../../../../purchases"

export const ExpenseSupplierListLoader = () => (
    <ListLoaderWrapper table={TableName.SUPPLIERS}>
        <SupplierList productSupplier={false} />
    </ListLoaderWrapper>
)
